<template>
    <div class="flex items-center justify-center h-screen">
        <img src="/images/logo.svg" alt="Unified.to" class="h-24 rounded animate-spin-slow mr-12" />
        <h1 class="text-8xl font-bold colour">404</h1>
        <a href="/" class="block btn btn-primary ml-12">Go home &gt;</a>
    </div>
</template>
